/** News API service. */

import { apiClient } from '../client';
import { API_ENDPOINTS } from '../endpoints';
import type { NewsResponse } from '@/types/responses';
import { withDedupe } from '@/utils/requestDedupe';

export async function fetchNewsData(refresh: boolean = false): Promise<NewsResponse | null> {
  return withDedupe(`news:v1:${refresh ? '1' : '0'}`, async () => {
    try {
      const url = refresh ? `${API_ENDPOINTS.news}?refresh=true` : API_ENDPOINTS.news;
      const response = await apiClient.get<NewsResponse>(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching news data:', error);
      throw error;
    }
  });
}

